<template>
    <div class="reservation-trends">
        <!-- Header hidden for now
        <div class="trends-header">
            <span class="header-time">12:00 - 23 {{ $t('statistics_v3.charts.reservations') }}</span>
        </div>
        -->
        <div class="trend-rows">
            <div v-for="(item, index) in data" :key="index" class="trend-row">
                <div class="trend-info">
                    <span class="trend-label">{{ item.label }}</span>
                    <span class="trend-count">{{ item.count }}</span>
                </div>

                <div class="trend-weather">
                    <span class="weather-temp">{{ item.temp }}</span>
                    <div class="weather-icon">
                        <img v-if="item.iconUrl" :src="item.iconUrl" alt="weather" class="weather-img" />
                        <template v-else>
                            <i v-if="item.icon === 'sun'" class="fas fa-sun" style="color: #fec400"></i>
                            <i v-else-if="item.icon === 'rain'" class="fas fa-cloud-showers-heavy" style="color: #a0aec0"></i>
                            <i v-else class="fas fa-cloud-sun" style="color: #fff"></i>
                        </template>
                    </div>
                </div>

                <!-- Chart hidden for now, to be implemented later
                <div class="trend-chart">
                    <svg viewBox="0 0 100 30" preserveAspectRatio="none">
                        <path
                            :d="generatePath(item.chartData)"
                            fill="none"
                            :stroke="item.trend === 'up' ? '#00D589' : '#C52B21'"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
                -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReservationTrends',
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
    methods: {
        generatePath(data) {
            if (!data || data.length === 0) return ''
            const width = 100
            const height = 30
            const max = Math.max(...data)
            const min = Math.min(...data)
            const range = max - min || 1
            const stepX = width / (data.length - 1)

            return data
                .map((val, i) => {
                    const x = i * stepX
                    const y = height - ((val - min) / range) * height // Invert Y
                    return `${i === 0 ? 'M' : 'L'} ${x} ${y}`
                })
                .join(' ')
        },
    },
}
</script>

<style scoped>
.reservation-trends {
    width: 100%;
    color: #fff;
    font-family: 'Poppins', sans-serif;
}

.trends-header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
}

.header-time {
    background: #1e1b39;
    padding: 6px 12px;
    border-radius: 8px;
    font-size: 12px;
    color: #a0aec0;
}

.trend-rows {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.trend-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    padding-bottom: 10px;
}

.trend-row:last-child {
    border-bottom: none;
}

.trend-info {
    display: flex;
    flex-direction: column;
    width: 120px;
}

.trend-label {
    font-size: 12px;
    color: #a0aec0;
}

.trend-count {
    font-size: 18px;
    font-weight: 700;
    color: #fff;
}

.trend-weather {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 80px;
}

.weather-temp {
    font-size: 16px;
    font-weight: 600;
}

.weather-icon {
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.weather-img {
    width: 35px;
    height: 35px;
    object-fit: contain;
}

.trend-chart {
    flex: 1;
    height: 35px;
    margin-left: 20px;
}

.trend-chart svg {
    width: 100%;
    height: 100%;
}
</style>
